<div>
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title">
        Product Audit View - {{ productName }}
      </h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="close()"
      >
        Close
      </button>
    </div>
    <div class="modal-body container" ngbAutofocus>
      <app-dc-alert-inner></app-dc-alert-inner>
      <app-dc-pane
        [noHeader]="true"
        [loading]="loading"
        [noScrollBar]="true"
        class="pane"
      >
        <app-dc-table
          id="audit-records-table"
          #table
          class="no-footer table"
          [rows]="rows"
          [columns]="columns"
          [messages]="messages"
          [scrollV]="false"
        ></app-dc-table>
      </app-dc-pane>
    </div>
  </div>
  